import React, { useState, useEffect, useContext } from "react"
// import Loader1 from "../interceptors/loader-interceptor"
import { getBranchList, getBranchRm } from "../services/rm-led-service"
import lookup from "../../static/lookup.json"
import journeyssr from "../../static/journeyssr.json"



export default function Rmled(props) {
  const [allBranchdata, setAllBranchData] = useState([])
  const [allRm, setAllRm] = useState([])
  const [isRMVisible, setisRMVisible] = useState(false)
  const HSBCBranchNew = {BRANCH_ID: 'HSBCGiftCity', BRANCH_LOCATION: 'HSBCGiftCity'};
  const RMdataHsbcGiftCity = [
    {
      BRANCHID: "HSBCGiftCity",
      JV_RM_ID: "02",
      JV_RM_PHONE_NO: "",
      LEVEL1_EMAIL: "",
      LEVEL1_NAME: "GiftCity",
      LEVEL1_ID_SP:"119268"
    }
  ];
  
  useEffect(async () => {

    // const urlParams = new URLSearchParams(window.location.search)
    // let urlPart  =window.location.search.toLowerCase()
    // if(urlPart.includes('hsbc')){
    //   document.body.style.backgroundColor = "#ededed";
    // }

    try {
      // const res = await getBranchList("HSBC");
      // const data = res.data?.data;
      const data = [[]]
      data[0].push(HSBCBranchNew)
      setAllBranchData([...data])
      setisRMVisible(true)
    } catch (error) {
      console.log(error)
    }
  }, [])

  const [radio1, setRadio1] = useState("two")
  const [localValues, setLocalValues] = useState({
    branchName: "",
    relationshipManager: "",
  })
  const [showError, setShowError] = useState(false)

  const handleRadioChange = value => {
    setRadio1(value)
  }

  const handleChange = async ({ target }, value) => {
    console.log(target.value, value, "handle change target and value")

    if (value === "branch") {
      setLocalValues(prev => {
        return {
          ...prev,
          branchName: target.value,
        }
      })

   
      setAllRm([])
      
      if (target.value === "HSBCGiftCity") {
        setAllRm(RMdataHsbcGiftCity); 
        return;
      }
      try {
        const payload = {
          BRANCH_ID: target.value,
          CHANNEL_ID: "HSBC",
        }
        const res = await getBranchRm(payload)
        const data = res.data?.data[0]
        setAllRm([...data])
      } catch (error) {
        console.log(error)
      }
    } else if (value === "relation") {
      setLocalValues(prev => {
        return {
          ...prev,
          relationshipManager: target.value,
        }
      })
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (radio1 === "two") {
      if (localValues.branchName === "") {
        setShowError(true)
      } else if (localValues.relationshipManager === "") {
        setShowError(true)
      } else {
        let agentDetails = allRm.find(element => element["LEVEL1_ID_SP"] === localValues.relationshipManager)
        let branchDetails = allBranchdata[0]?.find(element => element["BRANCH_ID"] === localValues.branchName)
        // console.log(agentDetails, branchDetails, "ffijfji1" )
        let rmData = {...agentDetails, ...branchDetails}
        console.log(rmData, "ffijfji2")

        setShowError(false)
        props.isJourneyStart(rmData)
      }
    } else {
      setShowError(false)
      props.isJourneyStart({})
      let a = journeyssr?.data?.products?.[0]?.journeys?.[0]?.journeyId
      console.log(journeyssr?.data?.products?.[0]?.journeys?.[0]?.journeyId);
      if(lookup.fnaValidPlans.includes(journeyssr?.data?.products?.[0]?.journeys?.[0]?.journeyId)){
        window.location.href = `${process.env.GATSBY_FNA_LINK}`;
      }else{
        return
      }
    }
  }

  return (
    <>
    <style>
      {
        `
        .container1{
          width: 100%;
          padding-right: var(--bs-gutter-x, .75rem);
          padding-left: var(--bs-gutter-x, 2rem);
          margin-right: auto;
          margin-left: auto;
           }
        .iselect-box-design1 {
          padding: 20px 0px;
          border-radius: 10px;
          position: relative;
           }
        `
      }
    </style>
      {isRMVisible ? (
        <div className="Q4-option2-design-structure" style={{ backgroundColor:"transparent"}} >
          <div className="container1">
            <div className="iselect-box-design1">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">
                    PLEASE ENTER DETAILS TO CONTINUE
                  </h1>
                </div>
              </div>

              <div className="iselect-mg-bottom mt-10">
                <div className="col-md-12 pl">
                    <div className="col-md-6 col-sm-6 at1-text active">
                      
                    </div>
                    <div className="col-md-6 col-sm-6 at1-text active">
                      <div className="radio-line check-rt">
                        <label className="customradio">
                          <div
                            className={`option-buit-design-new-structure-sde-box Q4-option-list-structure2 ${
                              radio1 === "two" ? "active" : ""
                            }`}
                          >
                            {" "}
                            <span className="radiotextsty"></span>
                            <input
                              checked="true"
                              type="radio"
                              name="radio1"
                              onChange={() => handleRadioChange("two")}
                            />
                            <span className="check-premium-payment checkmark">
                              <span className="fa fa-check check11"></span>
                            </span>
                            <div className="Q4-option-list-structure1-headline">
                              <p>
                                I am purchasing this product pursuant to
                                recommendation by an HSBC India Relationship
                                Manager basis Goal Planning journey.This journey
                                is not available for Non Resident Indian
                                customers, please contact your HSBC India
                                Relationship Manager for more details.
                              </p>
                            </div>
                          </div>
                        </label>
                      </div>
                    </div>
                </div>
              </div>

              <form>
                {radio1 === "two" && (
                  <div className="iselect-padding if-yes" id="div3">
                    <div className="iselect-mg-bottom mt-20 row">
                      <div className="col-md-6 col-xs-12 all-box-padding-right">
                        <div className="form-group">
                          <label className="title-bg inp-label"> Branch Name </label>
                          <select
                            className="select2 form-control"
                            name="a1"
                            value={localValues.branchName}
                            onChange={e => handleChange(e, "branch")}
                          >
                            <option value="">Select</option>
                            {allBranchdata[0].map(
                              (ele, index) =>
                                ele.BRANCH_ID &&
                                typeof ele.BRANCH_ID === "string" &&
                                ele.BRANCH_LOCATION &&
                                typeof ele.BRANCH_LOCATION === "string" && (
                                  <option
                                    key={ele.BRANCH_ID}
                                    value={ele.BRANCH_ID}
                                  >
                                    {ele.BRANCH_LOCATION}
                                  </option>
                                )
                            )}
                          </select>
                        </div>
                        {showError && localValues.branchName === "" && (
                          <div>
                            <label id="a1-error" className="error" for="a1">
                              Please select Branch Name
                            </label>
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 col-xs-12 all-box-padding-left">
                        <div className="form-group input-group">
                          <label className="title-bg inp-label">
                            Relationship Manager
                          </label>
                          <select
                            className="select2 form-control"
                            name="a2"
                            value={localValues.relationshipManager}
                            onChange={e => handleChange(e, "relation")}
                          >
                            <option value="">Select</option>
                            {allRm.map(
                              (ele, index) =>
                                ele.JV_RM_ID && ele.LEVEL1_ID_SP &&
                                typeof ele.JV_RM_ID === "string" && typeof ele.LEVEL1_ID_SP === "string" &&
                                ele.LEVEL1_NAME &&
                                typeof ele.LEVEL1_NAME === "string" && (
                                  <option
                                    key={ele.LEVEL1_ID_SP}
                                    value={ele.LEVEL1_ID_SP}
                                  >
                                    {ele.LEVEL1_ID_SP}
                                  </option>
                                )
                            )}
                          </select>
                        </div>
                        {showError && localValues.relationshipManager === "" && (
                          <div>
                            <label id="a2-error" className="error" for="a2">
                              Please select Relationship Manager
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div className="iselect-mg-bottom pd40 hidden-desktop-screen">
                  <div className="col-md-12">
                    <div className="but-center text-right">
                      {/* <div className="submit-btn cen">
                        {" "}
                        <a>Previous</a>{" "}
                      </div> */}

                      <input
                        className="previous-btn cen"
                        aria-hidden="true"
                        style={{
                          color: "white",
                          padding: "14px 50px",
                          border: "none",
                        }}
                        type="submit"
                        value="Submit"
                        onClick={handleSubmit}
                      />
                    </div>
                  </div>
                </div>
              </form>
              <div className="clearfix"></div>
              <div className="col-md-12 mt-30">
                <div className="note-detaile">
                  <h3 className="text-uppercase" style={{ fontWeight: "bold" }}>
                    {" "}
                    Note:
                  </h3>
                  <p>
                    {" "}
                    Please ensure your details provided in the application form match with your HSBC India Bank records. The payment for
                    this purchase needs to be done through your HSBC India Debit card, Credit card and Net Banking only.
                  </p>
                </div>
              </div>
              <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                    <div className="iselect-mg-bottom">
                      <div className="col-md-12">
                        <div className="but-center text-center">
                        <input
                        className="previous-btn cen"
                        aria-hidden="true"
                        style={{
                          color: "white",
                          padding: "14px 50px",
                          border: "none",
                        }}
                        type="submit"
                        value="Submit"
                        onClick={handleSubmit}
                      />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--mobile view button-->  */}
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  )
}
